/** productGroupSection별 교체/점검 주기 표기 (프론트 고정 값) */
export const REPLACEMENT_INTERVAL_BY_SECTION: Record<string, string> = {
  oil_set: '15,000km 마다 교환',
  tire: '50,000km 마다 교체',
  car_wash: '평균 3.3개월마다 세차',
  battery: '40,000km 마다 교체',
  wiper_blade: '8,000km 마다 교체',
  air_filter: '15,000km 마다 교체',
  cabin_filter: '15,000km 마다 교체',
  brake_pad: '60,000km 마다 교체',
  tire_rotation: '10,000km 마다 점검',
  air_conditioner: '2년마다 점검',
  wheel_alignment: '50,000km 마다 점검',
  oil_brake: '40,000km 마다 교체',
  spark_plug: '40,000km 마다 교체',
  antifreezer: '200,000km 마다 교체',
  oil_mission: '50,000km 마다 교체',
  fuel_cartridge: '40,000km 마다 교체',
  safe_inspect: '10,000km 마다 점검',
}
